__turbopack_context__.v({
  "carouselFooter": "RingAirProductCarousel-module__00-ZBG__carouselFooter",
  "carouselImageArea": "RingAirProductCarousel-module__00-ZBG__carouselImageArea",
  "realImagesPill": "RingAirProductCarousel-module__00-ZBG__realImagesPill",
  "root": "RingAirProductCarousel-module__00-ZBG__root",
});
